// extracted by mini-css-extract-plugin
module.exports = {"hdpFeebk":"hdpFeebk-3XRXzYxg","login":"login-38BY5f94"};